// eslint-disable-next-line @library/dependency-radar/valid-imports
import * as Yup from 'yup'

export const accountStepSchema = Yup.object({
  email: Yup.string().email().required(),
  password: Yup.string().min(8).required(),
})

export const deliveryStepSchema = Yup.object({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  phone: Yup.string().required(),
  houseNo: Yup.string().required(),
  street: Yup.string().required(),
  town: Yup.string().required(),
  postcode: Yup.string().required(),
})
